import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_systemDefaultFont25t9j5zn5vlep as get_systemDefaultFont,
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem_0,
  get_dp28ag147e4p5cz as get_dp,
  times16x024lmmohdt as times,
  plus2opbwe063z9pg as plus,
  divc3x3x4wqw206 as div,
} from './data.commonHtml.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
  protoOf180f3jzyo7rfj as protoOf,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  Companion_getInstance1ily2eb07zh6i as Companion_getInstance,
  Companion_getInstance2u620q9r4ejbj as Companion_getInstance_0,
  applyAlpha3k2fcxahu1lgz as applyAlpha,
  FadingColor3d6ef6zcqmlhk as FadingColor,
} from './Paint.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  FontAndStyle1comk0qshc8kn as FontAndStyle,
  divkhq3vjih9fcw as div_0,
} from './data.mjs';
import {
  Duration5ynfiptaqcrg as Duration,
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_1,
  toDuration28gf6ughsr3vf as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  RatioOfSpacing2du8cst35dyuc as RatioOfSpacing,
  AdaptiveToSpacing2muzuvljgg8be as AdaptiveToSpacing,
  PerCorner27xb33zgvi5gv as PerCorner,
  Fixed1p8lc8swyflir as Fixed,
  RatioOfSize1ip5bd7oxn8ba as RatioOfSize,
} from './CornerRadii.mjs';
import { CornerShape_Circular_getInstance1fe8iru495tm6 as CornerShape_Circular_getInstance } from './CornerShape.mjs';
import { Edges2jf5wl855ambv as Edges } from './Rect.mjs';
import { Companion_getInstance3htwskyquhuuo as Companion_getInstance_2 } from './ScreenTransitions.mjs';
import { DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { toList383f556t1dixk as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  plus2m1vv33moko5t as plus_0,
  emptyMapr06gerzljqtm as emptyMap,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_H1Semantic() {
  _init_properties_Theme_kt__w31tqv();
  return H1Semantic;
}
var H1Semantic;
function get_H2Semantic() {
  _init_properties_Theme_kt__w31tqv();
  return H2Semantic;
}
var H2Semantic;
function get_H3Semantic() {
  _init_properties_Theme_kt__w31tqv();
  return H3Semantic;
}
var H3Semantic;
function get_H4Semantic() {
  _init_properties_Theme_kt__w31tqv();
  return H4Semantic;
}
var H4Semantic;
function get_H5Semantic() {
  _init_properties_Theme_kt__w31tqv();
  return H5Semantic;
}
var H5Semantic;
var H6Semantic;
var ImportantSemanticClass;
function ImportantSemantic() {
  if (ImportantSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        ImportantSemantic_instance = null;
        super('imp');
        ImportantSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_background = theme.foreground_1;
        var tmp1_outline = theme.foreground_1;
        var tmp2_foreground = theme.background_1;
        return this.withBack$default_t8expd_k$(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_foreground, VOID, tmp1_outline, VOID, VOID, tmp0_background);
      }
      toString() {
        return 'ImportantSemantic';
      }
      hashCode() {
        return 1237157965;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ImportantSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'ImportantSemantic');
    ImportantSemanticClass = $;
  }
  return ImportantSemanticClass;
}
var ImportantSemantic_instance;
function ImportantSemantic_getInstance() {
  if (ImportantSemantic_instance === VOID)
    new (ImportantSemantic())();
  return ImportantSemantic_instance;
}
var ButtonSemanticClass;
function ButtonSemantic() {
  if (ButtonSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        ButtonSemantic_instance = null;
        super('btn');
        ButtonSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return theme.withoutBack_1;
      }
      toString() {
        return 'ButtonSemantic';
      }
      hashCode() {
        return 1469203699;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ButtonSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'ButtonSemantic');
    ButtonSemanticClass = $;
  }
  return ButtonSemanticClass;
}
var ButtonSemantic_instance;
function ButtonSemantic_getInstance() {
  if (ButtonSemantic_instance === VOID)
    new (ButtonSemantic())();
  return ButtonSemantic_instance;
}
var CardSemanticClass;
function CardSemantic() {
  if (CardSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        CardSemantic_instance = null;
        super('crd');
        CardSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return theme.withBack_1;
      }
      toString() {
        return 'CardSemantic';
      }
      hashCode() {
        return 312972689;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CardSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'CardSemantic');
    CardSemanticClass = $;
  }
  return CardSemanticClass;
}
var CardSemantic_instance;
function CardSemantic_getInstance() {
  if (CardSemantic_instance === VOID)
    new (CardSemantic())();
  return CardSemantic_instance;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.lookup_1 = [2.0, 1.6, 1.4, 1.3, 1.2, 1.1, 1.0, 0.8];
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_3() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var HeaderSizeSemanticClass;
function HeaderSizeSemantic() {
  if (HeaderSizeSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor(level) {
        Companion_getInstance_3();
        super('h' + level);
        this.level_1 = level;
      }
      default_buqihh_k$(theme) {
        return this.withoutBack$default_y4jue9_k$(theme, VOID, theme.font_1.copy$default_cfilcw_k$(VOID, VOID, VOID, VOID, VOID, VOID, get_rem(Companion_getInstance_3().lookup_1[this.level_1 - 1 | 0])));
      }
      toString() {
        return 'HeaderSizeSemantic(level=' + this.level_1 + ')';
      }
      hashCode() {
        return this.level_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HeaderSizeSemantic()))
          return false;
        if (!(this.level_1 === other.level_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'HeaderSizeSemantic');
    HeaderSizeSemanticClass = $;
  }
  return HeaderSizeSemanticClass;
}
var InstanceClass;
function Instance() {
  if (InstanceClass === VOID) {
    class $ {
      constructor(semantic) {
        this.semantic_1 = semantic;
      }
      toString() {
        return 'Instance(semantic=' + toString(this.semantic_1) + ')';
      }
      hashCode() {
        return hashCode(this.semantic_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Instance()))
          return false;
        if (!equals(this.semantic_1, other.semantic_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Instance');
    InstanceClass = $;
  }
  return InstanceClass;
}
var TypeClass;
function Type() {
  if (TypeClass === VOID) {
    class $ {
      constructor(type) {
        this.type_1 = type;
      }
      toString() {
        return 'Type(type=' + toString(this.type_1) + ')';
      }
      hashCode() {
        return this.type_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Type()))
          return false;
        if (!this.type_1.equals(other.type_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Type');
    TypeClass = $;
  }
  return TypeClass;
}
var OverrideClass;
function Override() {
  if (OverrideClass === VOID) {
    class $ {
      constructor(key, derivation) {
        return new.target.new_com_lightningkite_kiteui_models_Semantic_Override_u3us6_k$(key, derivation);
      }
      static new_com_lightningkite_kiteui_models_Semantic_Override_u3us6_k$(key, derivation) {
        var $this = createThis(this);
        $this.key_1 = key;
        $this.derivation_1 = derivation;
        return $this;
      }
      static new_com_lightningkite_kiteui_models_Semantic_Override_3gialy_k$(key, derivation) {
        return this.new_com_lightningkite_kiteui_models_Semantic_Override_u3us6_k$(new (Instance())(key), derivation);
      }
      toString() {
        return 'Override(key=' + toString(this.key_1) + ', derivation=' + toString(this.derivation_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.key_1);
        result = imul(result, 31) + hashCode(this.derivation_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Override()))
          return false;
        if (!equals(this.key_1, other.key_1))
          return false;
        if (!equals(this.derivation_1, other.derivation_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Override');
    OverrideClass = $;
  }
  return OverrideClass;
}
var SemanticClass;
function Semantic() {
  if (SemanticClass === VOID) {
    class $ {
      constructor(key) {
        this.key_1 = key;
      }
      default_buqihh_k$(theme) {
        return theme.withoutBack_1;
      }
      invoke_h6mny6_k$(theme) {
        return theme.get_6y9l0r_k$(this);
      }
      withBack_mpkmfz_k$(_this__u8e3s4, cascading, font, elevation, cornerRadii, cornerShape, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, semanticOverrides) {
        var tmp0_id = this.key_1;
        return _this__u8e3s4.copy_4x26id_k$(tmp0_id, cascading, font, elevation, cornerRadii, cornerShape, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, semanticOverrides).withBack_1;
      }
      withBack$default_t8expd_k$(_this__u8e3s4, cascading, font, elevation, cornerRadii, cornerShape, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, semanticOverrides, $super) {
        cascading = cascading === VOID ? true : cascading;
        font = font === VOID ? null : font;
        elevation = elevation === VOID ? null : elevation;
        cornerRadii = cornerRadii === VOID ? null : cornerRadii;
        cornerShape = cornerShape === VOID ? null : cornerShape;
        gap = gap === VOID ? null : gap;
        padding = padding === VOID ? null : padding;
        foreground = foreground === VOID ? null : foreground;
        iconOverride = iconOverride === VOID ? Companion_getInstance().INVALID_1 : iconOverride;
        outline = outline === VOID ? null : outline;
        outlineWidth = outlineWidth === VOID ? null : outlineWidth;
        separatorOverride = separatorOverride === VOID ? Companion_getInstance().INVALID_1 : separatorOverride;
        background = background === VOID ? null : background;
        blurBackground = blurBackground === VOID ? null : blurBackground;
        transform = transform === VOID ? null : transform;
        bodyTransitions = bodyTransitions === VOID ? null : bodyTransitions;
        dialogTransitions = dialogTransitions === VOID ? null : dialogTransitions;
        transitionDuration = transitionDuration === VOID ? null : transitionDuration;
        semanticOverrides = semanticOverrides === VOID ? Companion_getInstance_5().EMPTY_1 : semanticOverrides;
        var tmp;
        if ($super === VOID) {
          tmp = this.withBack_mpkmfz_k$(_this__u8e3s4, cascading, font, elevation, cornerRadii, cornerShape, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, semanticOverrides);
        } else {
          var tmp_0 = $super.withBack_mpkmfz_k$;
          var tmp_1 = elevation;
          var tmp_2 = tmp_1 == null ? null : new (Dimension())(tmp_1);
          var tmp_3 = gap;
          var tmp_4 = tmp_3 == null ? null : new (Dimension())(tmp_3);
          var tmp_5 = outlineWidth;
          var tmp_6 = tmp_5 == null ? null : new (Dimension())(tmp_5);
          var tmp_7 = blurBackground;
          var tmp_8 = tmp_7 == null ? null : new (Dimension())(tmp_7);
          var tmp_9 = transitionDuration;
          tmp = tmp_0.call(this, _this__u8e3s4, cascading, font, tmp_2, cornerRadii, cornerShape, tmp_4, padding, foreground, iconOverride, outline, tmp_6, separatorOverride, background, tmp_8, transform, bodyTransitions, dialogTransitions, tmp_9 == null ? null : new (Duration())(tmp_9), new (SemanticOverrides())(semanticOverrides));
        }
        return tmp;
      }
      withoutBack_vmx1gh_k$(_this__u8e3s4, cascading, font, elevation, cornerRadii, cornerShape, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, semanticOverrides) {
        var tmp0_id = this.key_1;
        return _this__u8e3s4.copy_4x26id_k$(tmp0_id, cascading, font, elevation, cornerRadii, cornerShape, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, semanticOverrides).withoutBack_1;
      }
      withoutBack$default_y4jue9_k$(_this__u8e3s4, cascading, font, elevation, cornerRadii, cornerShape, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, semanticOverrides, $super) {
        cascading = cascading === VOID ? true : cascading;
        font = font === VOID ? null : font;
        elevation = elevation === VOID ? null : elevation;
        cornerRadii = cornerRadii === VOID ? null : cornerRadii;
        cornerShape = cornerShape === VOID ? null : cornerShape;
        gap = gap === VOID ? null : gap;
        padding = padding === VOID ? null : padding;
        foreground = foreground === VOID ? null : foreground;
        iconOverride = iconOverride === VOID ? Companion_getInstance().INVALID_1 : iconOverride;
        outline = outline === VOID ? null : outline;
        outlineWidth = outlineWidth === VOID ? null : outlineWidth;
        separatorOverride = separatorOverride === VOID ? Companion_getInstance().INVALID_1 : separatorOverride;
        background = background === VOID ? null : background;
        blurBackground = blurBackground === VOID ? null : blurBackground;
        transform = transform === VOID ? null : transform;
        bodyTransitions = bodyTransitions === VOID ? null : bodyTransitions;
        dialogTransitions = dialogTransitions === VOID ? null : dialogTransitions;
        transitionDuration = transitionDuration === VOID ? null : transitionDuration;
        semanticOverrides = semanticOverrides === VOID ? Companion_getInstance_5().EMPTY_1 : semanticOverrides;
        var tmp;
        if ($super === VOID) {
          tmp = this.withoutBack_vmx1gh_k$(_this__u8e3s4, cascading, font, elevation, cornerRadii, cornerShape, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, semanticOverrides);
        } else {
          var tmp_0 = $super.withoutBack_vmx1gh_k$;
          var tmp_1 = elevation;
          var tmp_2 = tmp_1 == null ? null : new (Dimension())(tmp_1);
          var tmp_3 = gap;
          var tmp_4 = tmp_3 == null ? null : new (Dimension())(tmp_3);
          var tmp_5 = outlineWidth;
          var tmp_6 = tmp_5 == null ? null : new (Dimension())(tmp_5);
          var tmp_7 = blurBackground;
          var tmp_8 = tmp_7 == null ? null : new (Dimension())(tmp_7);
          var tmp_9 = transitionDuration;
          tmp = tmp_0.call(this, _this__u8e3s4, cascading, font, tmp_2, cornerRadii, cornerShape, tmp_4, padding, foreground, iconOverride, outline, tmp_6, separatorOverride, background, tmp_8, transform, bodyTransitions, dialogTransitions, tmp_9 == null ? null : new (Duration())(tmp_9), new (SemanticOverrides())(semanticOverrides));
        }
        return tmp;
      }
      alter_mfv5w8_k$(_this__u8e3s4, cascading, font, elevation, cornerRadii, cornerShape, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, semanticOverrides) {
        var tmp0_id = this.key_1;
        return _this__u8e3s4.copy_4x26id_k$(tmp0_id, cascading, font, elevation, cornerRadii, cornerShape, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, semanticOverrides);
      }
      alter$default_u3pj3s_k$(_this__u8e3s4, cascading, font, elevation, cornerRadii, cornerShape, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, semanticOverrides, $super) {
        cascading = cascading === VOID ? true : cascading;
        font = font === VOID ? null : font;
        elevation = elevation === VOID ? null : elevation;
        cornerRadii = cornerRadii === VOID ? null : cornerRadii;
        cornerShape = cornerShape === VOID ? null : cornerShape;
        gap = gap === VOID ? null : gap;
        padding = padding === VOID ? null : padding;
        foreground = foreground === VOID ? null : foreground;
        iconOverride = iconOverride === VOID ? Companion_getInstance().INVALID_1 : iconOverride;
        outline = outline === VOID ? null : outline;
        outlineWidth = outlineWidth === VOID ? null : outlineWidth;
        separatorOverride = separatorOverride === VOID ? Companion_getInstance().INVALID_1 : separatorOverride;
        background = background === VOID ? null : background;
        blurBackground = blurBackground === VOID ? null : blurBackground;
        transform = transform === VOID ? null : transform;
        bodyTransitions = bodyTransitions === VOID ? null : bodyTransitions;
        dialogTransitions = dialogTransitions === VOID ? null : dialogTransitions;
        transitionDuration = transitionDuration === VOID ? null : transitionDuration;
        semanticOverrides = semanticOverrides === VOID ? Companion_getInstance_5().EMPTY_1 : semanticOverrides;
        var tmp;
        if ($super === VOID) {
          tmp = this.alter_mfv5w8_k$(_this__u8e3s4, cascading, font, elevation, cornerRadii, cornerShape, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, semanticOverrides);
        } else {
          var tmp_0 = $super.alter_mfv5w8_k$;
          var tmp_1 = elevation;
          var tmp_2 = tmp_1 == null ? null : new (Dimension())(tmp_1);
          var tmp_3 = gap;
          var tmp_4 = tmp_3 == null ? null : new (Dimension())(tmp_3);
          var tmp_5 = outlineWidth;
          var tmp_6 = tmp_5 == null ? null : new (Dimension())(tmp_5);
          var tmp_7 = blurBackground;
          var tmp_8 = tmp_7 == null ? null : new (Dimension())(tmp_7);
          var tmp_9 = transitionDuration;
          tmp = tmp_0.call(this, _this__u8e3s4, cascading, font, tmp_2, cornerRadii, cornerShape, tmp_4, padding, foreground, iconOverride, outline, tmp_6, separatorOverride, background, tmp_8, transform, bodyTransitions, dialogTransitions, tmp_9 == null ? null : new (Duration())(tmp_9), new (SemanticOverrides())(semanticOverrides));
        }
        return tmp;
      }
    }
    protoOf($).plus_duvq05_k$ = plus_1;
    initMetadataForClass($, 'Semantic', VOID, VOID, [ThemeDerivation()]);
    SemanticClass = $;
  }
  return SemanticClass;
}
var ThemeAndBackClass;
function ThemeAndBack() {
  if (ThemeAndBackClass === VOID) {
    class $ {
      constructor(theme, drawBackground, padding) {
        this.theme_1 = theme;
        this.drawBackground_1 = drawBackground;
        this.padding_1 = padding;
      }
      get_6y9l0r_k$(semantic) {
        return this.plus_duvq05_k$(semantic);
      }
      plus_duvq05_k$(other) {
        var b = other.invoke_h6mny6_k$(this.theme_1);
        var tmp;
        if (this.drawBackground_1 || b.drawBackground_1) {
          var tmp_0;
          if (this.padding_1 || b.padding_1) {
            tmp_0 = b.theme_1.withBack_1;
          } else {
            tmp_0 = b.theme_1.withBackNoPadding_1;
          }
          tmp = tmp_0;
        } else {
          var tmp_1;
          if (this.padding_1 || b.padding_1) {
            tmp_1 = b.theme_1.withoutBackButPadding_1;
          } else {
            tmp_1 = b.theme_1.withoutBack_1;
          }
          tmp = tmp_1;
        }
        return tmp;
      }
      toString() {
        return 'ThemeAndBack(theme=' + this.theme_1.toString() + ', drawBackground=' + this.drawBackground_1 + ', padding=' + this.padding_1 + ')';
      }
      hashCode() {
        var result = this.theme_1.hashCode();
        result = imul(result, 31) + getBooleanHashCode(this.drawBackground_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.padding_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ThemeAndBack()))
          return false;
        if (!this.theme_1.equals(other.theme_1))
          return false;
        if (!(this.drawBackground_1 === other.drawBackground_1))
          return false;
        if (!(this.padding_1 === other.padding_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ThemeAndBack');
    ThemeAndBackClass = $;
  }
  return ThemeAndBackClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.placeholder_1 = new (Theme())('placeholder');
        this.randomGenId_1 = 0;
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_4() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var DebuggerClass;
function Debugger() {
  if (DebuggerClass === VOID) {
    class $ {
      constructor() {
        Debugger_instance = this;
        this.checkIdCollisions_1 = false;
        this.seen_1 = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
      }
      checkAndRegister_7ucym7_k$(theme) {
        var prior = this.seen_1.get_wei43m_k$(theme.id_1);
        if (prior == null) {
          var tmp0 = this.seen_1;
          // Inline function 'kotlin.collections.set' call
          var key = theme.id_1;
          tmp0.put_4fpzoq_k$(key, theme);
        } else {
          // Inline function 'kotlin.check' call
          if (!prior.structurallyEquals_bpxpie_k$(theme)) {
            var message = "Theme id collision: two structurally different Themes both use id '" + theme.id_1 + "'. " + "Themes must be derived through semantic derivation (Theme.copy, semantics, the withBack/withoutBack/alter helpers) so ids stay unique - look for a manually-assigned or non-chained id, e.g. from Theme.customize. Differing semanticOverrides count as a difference: on the HTML targets a theme reaches the DOM as a single class named after its id, so the losing theme renders with the winner's CSS and its overrides appear to do nothing.";
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
          }
        }
      }
    }
    initMetadataForObject($, 'Debugger');
    DebuggerClass = $;
  }
  return DebuggerClass;
}
var Debugger_instance;
function Debugger_getInstance() {
  if (Debugger_instance === VOID)
    new (Debugger())();
  return Debugger_instance;
}
var ThemeClass;
function Theme() {
  if (ThemeClass === VOID) {
    class $ {
      constructor(id, font, elevation, cornerRadii, cornerShape, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, derivedFrom, derivationId, revert, semanticOverrides) {
        Companion_getInstance_4();
        font = font === VOID ? new (FontAndStyle())(get_systemDefaultFont()) : font;
        elevation = elevation === VOID ? get_px(1) : elevation;
        cornerRadii = cornerRadii === VOID ? new (RatioOfSpacing())(1.0) : cornerRadii;
        cornerShape = cornerShape === VOID ? CornerShape_Circular_getInstance() : cornerShape;
        gap = gap === VOID ? get_rem_0(1) : gap;
        padding = padding === VOID ? Edges().new_com_lightningkite_kiteui_models_Edges_h2jw3i_k$(gap) : padding;
        foreground = foreground === VOID ? Companion_getInstance_0().black_1 : foreground;
        iconOverride = iconOverride === VOID ? null : iconOverride;
        outline = outline === VOID ? Companion_getInstance_0().black_1 : outline;
        outlineWidth = outlineWidth === VOID ? get_px(0) : outlineWidth;
        separatorOverride = separatorOverride === VOID ? null : separatorOverride;
        background = background === VOID ? Companion_getInstance_0().white_1 : background;
        blurBackground = blurBackground === VOID ? get_px(0) : blurBackground;
        transform = transform === VOID ? null : transform;
        bodyTransitions = bodyTransitions === VOID ? Companion_getInstance_2().Fade_1 : bodyTransitions;
        dialogTransitions = dialogTransitions === VOID ? Companion_getInstance_2().Fade_1 : dialogTransitions;
        var tmp;
        if (transitionDuration === VOID) {
          // Inline function 'kotlin.time.Companion.seconds' call
          Companion_getInstance_1();
          tmp = toDuration(0.25, DurationUnit_SECONDS_getInstance());
        } else {
          tmp = transitionDuration;
        }
        transitionDuration = tmp;
        derivedFrom = derivedFrom === VOID ? null : derivedFrom;
        derivationId = derivationId === VOID ? null : derivationId;
        revert = revert === VOID ? null : revert;
        semanticOverrides = semanticOverrides === VOID ? Companion_getInstance_5().EMPTY_1 : semanticOverrides;
        this.id_1 = id;
        this.font_1 = font;
        this.elevation_1 = elevation;
        this.cornerRadii_1 = cornerRadii;
        this.cornerShape_1 = cornerShape;
        this.gap_1 = gap;
        this.padding_1 = padding;
        this.foreground_1 = foreground;
        this.iconOverride_1 = iconOverride;
        this.outline_1 = outline;
        this.outlineWidth_1 = outlineWidth;
        this.separatorOverride_1 = separatorOverride;
        this.background_1 = background;
        this.blurBackground_1 = blurBackground;
        this.transform_1 = transform;
        this.bodyTransitions_1 = bodyTransitions;
        this.dialogTransitions_1 = dialogTransitions;
        this.transitionDuration_1 = transitionDuration;
        this.derivedFrom_1 = derivedFrom;
        this.derivationId_1 = derivationId;
        this.revert_1 = revert;
        this.semanticOverrides_1 = semanticOverrides;
        if (Debugger_getInstance().checkIdCollisions_1) {
          Debugger_getInstance().checkAndRegister_7ucym7_k$(this);
        }
        this.withBack_1 = new (ThemeAndBack())(this, true, true);
        this.withBackNoPadding_1 = new (ThemeAndBack())(this, true, false);
        this.withoutBack_1 = new (ThemeAndBack())(this, false, false);
        this.withoutBackButPadding_1 = new (ThemeAndBack())(this, false, true);
        this.themeCache_1 = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
      }
      get_icon_wont8i_k$() {
        var tmp0_elvis_lhs = this.iconOverride_1;
        return tmp0_elvis_lhs == null ? this.foreground_1 : tmp0_elvis_lhs;
      }
      get_separator_xuwon8_k$() {
        var tmp0_elvis_lhs = this.separatorOverride_1;
        return tmp0_elvis_lhs == null ? applyAlpha(this.foreground_1, 0.5) : tmp0_elvis_lhs;
      }
      get_6y9l0r_k$(semantic) {
        // Inline function 'kotlin.collections.getOrPut' call
        var this_0 = this.themeCache_1;
        var value = this_0.get_wei43m_k$(semantic);
        var tmp;
        if (value == null) {
          var answer = SemanticOverrides__derive_impl_4a9vxh(this.semanticOverrides_1, semantic, this);
          this_0.put_4fpzoq_k$(semantic, answer);
          tmp = answer;
        } else {
          tmp = value;
        }
        return tmp;
      }
      hashCode() {
        return getStringHashCode(this.id_1);
      }
      equals(other) {
        var tmp;
        if (other instanceof Theme()) {
          tmp = this.id_1 === other.id_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      structurallyEquals_bpxpie_k$(other) {
        return this.font_1.equals(other.font_1) && equals(this.elevation_1, other.elevation_1) && equals(this.cornerRadii_1, other.cornerRadii_1) && this.cornerShape_1.equals(other.cornerShape_1) && equals(this.gap_1, other.gap_1) && this.padding_1.equals(other.padding_1) && equals(this.foreground_1, other.foreground_1) && equals(this.iconOverride_1, other.iconOverride_1) && equals(this.outline_1, other.outline_1) && equals(this.outlineWidth_1, other.outlineWidth_1) && equals(this.separatorOverride_1, other.separatorOverride_1) && equals(this.background_1, other.background_1) && equals(this.blurBackground_1, other.blurBackground_1) && equals(this.transform_1, other.transform_1) && this.bodyTransitions_1.equals(other.bodyTransitions_1) && this.dialogTransitions_1.equals(other.dialogTransitions_1) && equals(new (Duration())(this.transitionDuration_1), new (Duration())(other.transitionDuration_1)) && equals(this.semanticOverrides_1, other.semanticOverrides_1);
      }
      copy_4x26id_k$(id, cascading, font, elevation, cornerRadii, cornerShape, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, semanticOverrides) {
        var tmp17_id = this.id_1 + '-' + id;
        var tmp18_derivedFrom = this.derivedFrom_1;
        var tmp19_derivationId = this.derivationId_1;
        var tmp20_font = font == null ? this.font_1 : font;
        var tmp;
        var tmp_0 = elevation;
        if ((tmp_0 == null ? null : new (Dimension())(tmp_0)) == null) {
          tmp = this.elevation_1;
        } else {
          tmp = elevation;
        }
        var tmp21_elevation = tmp;
        var tmp22_cornerRadii = cornerRadii == null ? this.cornerRadii_1 : cornerRadii;
        var tmp23_cornerShape = cornerShape == null ? this.cornerShape_1 : cornerShape;
        var tmp_1;
        var tmp_2 = gap;
        if ((tmp_2 == null ? null : new (Dimension())(tmp_2)) == null) {
          tmp_1 = this.gap_1;
        } else {
          tmp_1 = gap;
        }
        var tmp24_gap = tmp_1;
        var tmp25_padding = padding == null ? this.padding_1 : padding;
        var tmp26_foreground = foreground == null ? this.foreground_1 : foreground;
        var tmp27_iconOverride = equals(iconOverride, Companion_getInstance().INVALID_1) ? this.iconOverride_1 : iconOverride;
        var tmp28_outline = outline == null ? this.outline_1 : outline;
        var tmp_3;
        var tmp_4 = outlineWidth;
        if ((tmp_4 == null ? null : new (Dimension())(tmp_4)) == null) {
          tmp_3 = this.outlineWidth_1;
        } else {
          tmp_3 = outlineWidth;
        }
        var tmp29_outlineWidth = tmp_3;
        var tmp30_separatorOverride = equals(separatorOverride, Companion_getInstance().INVALID_1) ? this.separatorOverride_1 : separatorOverride;
        var tmp31_background = background == null ? this.background_1 : background;
        var tmp_5;
        var tmp_6 = blurBackground;
        if ((tmp_6 == null ? null : new (Dimension())(tmp_6)) == null) {
          tmp_5 = this.blurBackground_1;
        } else {
          tmp_5 = blurBackground;
        }
        var tmp32_blurBackground = tmp_5;
        var tmp33_transform = transform == null ? this.transform_1 : transform;
        var tmp34_bodyTransitions = bodyTransitions == null ? this.bodyTransitions_1 : bodyTransitions;
        var tmp35_dialogTransitions = dialogTransitions == null ? this.dialogTransitions_1 : dialogTransitions;
        var tmp_7;
        var tmp_8 = transitionDuration;
        if ((tmp_8 == null ? null : new (Duration())(tmp_8)) == null) {
          tmp_7 = this.transitionDuration_1;
        } else {
          tmp_7 = transitionDuration;
        }
        var tmp36_transitionDuration = tmp_7;
        var tmp37_semanticOverrides = SemanticOverrides__plus_impl_6gwlwu(this.semanticOverrides_1, semanticOverrides);
        var tmp_9;
        if (!cascading) {
          var tmp15_elvis_lhs = this.revert_1;
          tmp_9 = tmp15_elvis_lhs == null ? this : tmp15_elvis_lhs;
        } else {
          var tmp16_safe_receiver = this.revert_1;
          tmp_9 = tmp16_safe_receiver == null ? null : tmp16_safe_receiver.copy_4x26id_k$(id, cascading, font, elevation, cornerRadii, cornerShape, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, semanticOverrides);
        }
        var tmp38_revert = tmp_9;
        return new (Theme())(tmp17_id, tmp20_font, tmp21_elevation, tmp22_cornerRadii, tmp23_cornerShape, tmp24_gap, tmp25_padding, tmp26_foreground, tmp27_iconOverride, tmp28_outline, tmp29_outlineWidth, tmp30_separatorOverride, tmp31_background, tmp32_blurBackground, tmp33_transform, tmp34_bodyTransitions, tmp35_dialogTransitions, tmp36_transitionDuration, tmp18_derivedFrom, tmp19_derivationId, tmp38_revert, tmp37_semanticOverrides);
      }
      copy$default_vpegf4_k$(id, cascading, font, elevation, cornerRadii, cornerShape, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, semanticOverrides, $super) {
        cascading = cascading === VOID ? true : cascading;
        font = font === VOID ? null : font;
        elevation = elevation === VOID ? null : elevation;
        cornerRadii = cornerRadii === VOID ? null : cornerRadii;
        cornerShape = cornerShape === VOID ? null : cornerShape;
        gap = gap === VOID ? null : gap;
        padding = padding === VOID ? null : padding;
        foreground = foreground === VOID ? null : foreground;
        iconOverride = iconOverride === VOID ? Companion_getInstance().INVALID_1 : iconOverride;
        outline = outline === VOID ? null : outline;
        outlineWidth = outlineWidth === VOID ? null : outlineWidth;
        separatorOverride = separatorOverride === VOID ? Companion_getInstance().INVALID_1 : separatorOverride;
        background = background === VOID ? null : background;
        blurBackground = blurBackground === VOID ? null : blurBackground;
        transform = transform === VOID ? null : transform;
        bodyTransitions = bodyTransitions === VOID ? null : bodyTransitions;
        dialogTransitions = dialogTransitions === VOID ? null : dialogTransitions;
        transitionDuration = transitionDuration === VOID ? null : transitionDuration;
        semanticOverrides = semanticOverrides === VOID ? Companion_getInstance_5().EMPTY_1 : semanticOverrides;
        var tmp;
        if ($super === VOID) {
          tmp = this.copy_4x26id_k$(id, cascading, font, elevation, cornerRadii, cornerShape, gap, padding, foreground, iconOverride, outline, outlineWidth, separatorOverride, background, blurBackground, transform, bodyTransitions, dialogTransitions, transitionDuration, semanticOverrides);
        } else {
          var tmp_0 = $super.copy_4x26id_k$;
          var tmp_1 = elevation;
          var tmp_2 = tmp_1 == null ? null : new (Dimension())(tmp_1);
          var tmp_3 = gap;
          var tmp_4 = tmp_3 == null ? null : new (Dimension())(tmp_3);
          var tmp_5 = outlineWidth;
          var tmp_6 = tmp_5 == null ? null : new (Dimension())(tmp_5);
          var tmp_7 = blurBackground;
          var tmp_8 = tmp_7 == null ? null : new (Dimension())(tmp_7);
          var tmp_9 = transitionDuration;
          tmp = tmp_0.call(this, id, cascading, font, tmp_2, cornerRadii, cornerShape, tmp_4, padding, foreground, iconOverride, outline, tmp_6, separatorOverride, background, tmp_8, transform, bodyTransitions, dialogTransitions, tmp_9 == null ? null : new (Duration())(tmp_9), new (SemanticOverrides())(semanticOverrides));
        }
        return tmp;
      }
      toString() {
        return this.id_1;
      }
    }
    initMetadataForClass($, 'Theme');
    ThemeClass = $;
  }
  return ThemeClass;
}
var NoneClass;
function None() {
  if (NoneClass === VOID) {
    class $ {
      invoke_h6mny6_k$(theme) {
        return theme.withoutBack_1;
      }
      plus_duvq05_k$(other) {
        return other;
      }
      toString() {
        return 'None';
      }
      hashCode() {
        return -1193393471;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof None()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'None', VOID, VOID, [ThemeDerivation()]);
    NoneClass = $;
  }
  return NoneClass;
}
var None_instance;
function None_getInstance() {
  return None_instance;
}
var SetClass;
function Set() {
  if (SetClass === VOID) {
    class $ {}
    initMetadataForClass($, 'Set', VOID, VOID, [ThemeDerivation()]);
    SetClass = $;
  }
  return SetClass;
}
var SetAsBaseClass;
function SetAsBase() {
  if (SetAsBaseClass === VOID) {
    class $ {
      constructor(theme) {
        this.theme_1 = theme;
      }
      invoke_h6mny6_k$(theme) {
        return this.theme_1.withBackNoPadding_1;
      }
      toString() {
        return 'SetAsBase(theme=' + this.theme_1.toString() + ')';
      }
      hashCode() {
        return this.theme_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SetAsBase()))
          return false;
        if (!this.theme_1.equals(other.theme_1))
          return false;
        return true;
      }
    }
    protoOf($).plus_duvq05_k$ = plus_1;
    initMetadataForClass($, 'SetAsBase', VOID, VOID, [ThemeDerivation()]);
    SetAsBaseClass = $;
  }
  return SetAsBaseClass;
}
var ChainClass;
function Chain() {
  if (ChainClass === VOID) {
    class $ {
      constructor(left, right) {
        this.left_1 = left;
        this.right_1 = right;
      }
      invoke_h6mny6_k$(theme) {
        return this.left_1.invoke_h6mny6_k$(theme).plus_duvq05_k$(this.right_1);
      }
      toString() {
        return 'Chain(left=' + toString(this.left_1) + ', right=' + toString(this.right_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.left_1);
        result = imul(result, 31) + hashCode(this.right_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Chain()))
          return false;
        if (!equals(this.left_1, other.left_1))
          return false;
        if (!equals(this.right_1, other.right_1))
          return false;
        return true;
      }
    }
    protoOf($).plus_duvq05_k$ = plus_1;
    initMetadataForClass($, 'Chain', VOID, VOID, [ThemeDerivation()]);
    ChainClass = $;
  }
  return ChainClass;
}
function plus_1(other) {
  var tmp;
  if (other instanceof Set()) {
    tmp = other;
  } else {
    if (other instanceof SetAsBase()) {
      tmp = other;
    } else {
      tmp = new (Chain())(this, other);
    }
  }
  return tmp;
}
var ThemeDerivationClass;
function ThemeDerivation() {
  if (ThemeDerivationClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ThemeDerivation');
    ThemeDerivationClass = $;
  }
  return ThemeDerivationClass;
}
var TransformationClass;
function Transformation() {
  if (TransformationClass === VOID) {
    class $ {
      constructor(translationX, translationY, translationZ, rotationX, rotationY, rotation, scaleX, scaleY) {
        translationX = translationX === VOID ? 0.0 : translationX;
        translationY = translationY === VOID ? 0.0 : translationY;
        translationZ = translationZ === VOID ? 0.0 : translationZ;
        rotationX = rotationX === VOID ? 0.0 : rotationX;
        rotationY = rotationY === VOID ? 0.0 : rotationY;
        rotation = rotation === VOID ? 0.0 : rotation;
        scaleX = scaleX === VOID ? 1.0 : scaleX;
        scaleY = scaleY === VOID ? 1.0 : scaleY;
        this.translationX_1 = translationX;
        this.translationY_1 = translationY;
        this.translationZ_1 = translationZ;
        this.rotationX_1 = rotationX;
        this.rotationY_1 = rotationY;
        this.rotation_1 = rotation;
        this.scaleX_1 = scaleX;
        this.scaleY_1 = scaleY;
      }
      toString() {
        return 'Transformation(translationX=' + this.translationX_1 + ', translationY=' + this.translationY_1 + ', translationZ=' + this.translationZ_1 + ', rotationX=' + this.rotationX_1 + ', rotationY=' + this.rotationY_1 + ', rotation=' + this.rotation_1 + ', scaleX=' + this.scaleX_1 + ', scaleY=' + this.scaleY_1 + ')';
      }
      hashCode() {
        var result = getNumberHashCode(this.translationX_1);
        result = imul(result, 31) + getNumberHashCode(this.translationY_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.translationZ_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.rotationX_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.rotationY_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.rotation_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.scaleX_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.scaleY_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Transformation()))
          return false;
        if (!equals(this.translationX_1, other.translationX_1))
          return false;
        if (!equals(this.translationY_1, other.translationY_1))
          return false;
        if (!equals(this.translationZ_1, other.translationZ_1))
          return false;
        if (!equals(this.rotationX_1, other.rotationX_1))
          return false;
        if (!equals(this.rotationY_1, other.rotationY_1))
          return false;
        if (!equals(this.rotation_1, other.rotation_1))
          return false;
        if (!equals(this.scaleX_1, other.scaleX_1))
          return false;
        if (!equals(this.scaleY_1, other.scaleY_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Transformation', Transformation);
    TransformationClass = $;
  }
  return TransformationClass;
}
function _SemanticOverrides___init__impl__g2p3k8(overrides) {
  return overrides;
}
function _get_overrides__k260ay($this) {
  return $this;
}
function _SemanticOverrides___init__impl__g2p3k8_0(overrides) {
  // Inline function 'kotlin.collections.associate' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(overrides, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
  var _iterator__ex2g4s = overrides.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.derivation_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var pair = to(element.key_1, typeof tmp === 'function' ? tmp : THROW_CCE());
    destination.put_4fpzoq_k$(pair.first_1, pair.second_1);
  }
  return _SemanticOverrides___init__impl__g2p3k8(destination);
}
function _SemanticOverrides___init__impl__g2p3k8_1(overrides) {
  return _SemanticOverrides___init__impl__g2p3k8_0(toList(overrides));
}
function SemanticOverrides__derive_impl_4a9vxh($this, key, theme) {
  var tmp0_elvis_lhs = _get_overrides__k260ay($this).get_wei43m_k$(new (Instance())(key));
  var definition = tmp0_elvis_lhs == null ? _get_overrides__k260ay($this).get_wei43m_k$(new (Type())(getKClassFromExpression(key))) : tmp0_elvis_lhs;
  var tmp2_elvis_lhs = definition == null ? null : definition(key, theme);
  return tmp2_elvis_lhs == null ? key.default_buqihh_k$(theme) : tmp2_elvis_lhs;
}
function SemanticOverrides__plus_impl_6gwlwu($this, other) {
  return _SemanticOverrides___init__impl__g2p3k8(plus_0(_get_overrides__k260ay($this), _get_overrides__k260ay(other)));
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        this.EMPTY_1 = _SemanticOverrides___init__impl__g2p3k8(emptyMap());
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_5() {
  if (Companion_instance_1 === VOID)
    new (Companion_1())();
  return Companion_instance_1;
}
function SemanticOverrides__toString_impl_ptrls0($this) {
  return 'SemanticOverrides(overrides=' + toString($this) + ')';
}
function SemanticOverrides__hashCode_impl_42loz5($this) {
  return hashCode($this);
}
function SemanticOverrides__equals_impl_rmg7ub($this, other) {
  if (!(other instanceof SemanticOverrides()))
    return false;
  var tmp0_other_with_cast = other.overrides_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var SemanticOverridesClass;
function SemanticOverrides() {
  if (SemanticOverridesClass === VOID) {
    class $ {
      constructor(overrides) {
        Companion_getInstance_5();
        this.overrides_1 = overrides;
      }
      toString() {
        return SemanticOverrides__toString_impl_ptrls0(this.overrides_1);
      }
      hashCode() {
        return SemanticOverrides__hashCode_impl_42loz5(this.overrides_1);
      }
      equals(other) {
        return SemanticOverrides__equals_impl_rmg7ub(this.overrides_1, other);
      }
    }
    initMetadataForClass($, 'SemanticOverrides');
    SemanticOverridesClass = $;
  }
  return SemanticOverridesClass;
}
var HeaderSemanticClass;
function HeaderSemantic() {
  if (HeaderSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        HeaderSemantic_instance = null;
        super('hed');
        HeaderSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return theme.withoutBack_1;
      }
      toString() {
        return 'HeaderSemantic';
      }
      hashCode() {
        return -1605536434;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HeaderSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'HeaderSemantic');
    HeaderSemanticClass = $;
  }
  return HeaderSemanticClass;
}
var HeaderSemantic_instance;
function HeaderSemantic_getInstance() {
  if (HeaderSemantic_instance === VOID)
    new (HeaderSemantic())();
  return HeaderSemantic_instance;
}
function override(_this__u8e3s4, derivation) {
  _init_properties_Theme_kt__w31tqv();
  return Override().new_com_lightningkite_kiteui_models_Semantic_Override_3gialy_k$(_this__u8e3s4, derivation);
}
var OuterSemanticClass;
function OuterSemantic() {
  if (OuterSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        OuterSemantic_instance = null;
        super('outer');
        OuterSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return theme.withoutBack_1;
      }
      toString() {
        return 'OuterSemantic';
      }
      hashCode() {
        return 996540966;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof OuterSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'OuterSemantic');
    OuterSemanticClass = $;
  }
  return OuterSemanticClass;
}
var OuterSemantic_instance;
function OuterSemantic_getInstance() {
  if (OuterSemantic_instance === VOID)
    new (OuterSemantic())();
  return OuterSemantic_instance;
}
var MainContentSemanticClass;
function MainContentSemantic() {
  if (MainContentSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        MainContentSemantic_instance = null;
        super('cnt');
        MainContentSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return theme.withBack_1;
      }
      toString() {
        return 'MainContentSemantic';
      }
      hashCode() {
        return 446937451;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MainContentSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'MainContentSemantic');
    MainContentSemanticClass = $;
  }
  return MainContentSemanticClass;
}
var MainContentSemantic_instance;
function MainContentSemantic_getInstance() {
  if (MainContentSemantic_instance === VOID)
    new (MainContentSemantic())();
  return MainContentSemantic_instance;
}
var BarSemanticClass;
function BarSemantic() {
  if (BarSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        BarSemantic_instance = null;
        super('bar');
        BarSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return theme.get_6y9l0r_k$(ImportantSemantic_getInstance());
      }
      toString() {
        return 'BarSemantic';
      }
      hashCode() {
        return 1257583358;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof BarSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'BarSemantic');
    BarSemanticClass = $;
  }
  return BarSemanticClass;
}
var BarSemantic_instance;
function BarSemantic_getInstance() {
  if (BarSemantic_instance === VOID)
    new (BarSemantic())();
  return BarSemantic_instance;
}
var NavSemanticClass;
function NavSemantic() {
  if (NavSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        NavSemantic_instance = null;
        super('nav');
        NavSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return theme.get_6y9l0r_k$(BarSemantic_getInstance());
      }
      toString() {
        return 'NavSemantic';
      }
      hashCode() {
        return -1765847026;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof NavSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'NavSemantic');
    NavSemanticClass = $;
  }
  return NavSemanticClass;
}
var NavSemantic_instance;
function NavSemantic_getInstance() {
  if (NavSemantic_instance === VOID)
    new (NavSemantic())();
  return NavSemantic_instance;
}
var ListSemanticClass;
function ListSemantic() {
  if (ListSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        ListSemantic_instance = null;
        super('lst');
        ListSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return theme.withoutBack_1;
      }
      toString() {
        return 'ListSemantic';
      }
      hashCode() {
        return 932994335;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ListSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'ListSemantic');
    ListSemanticClass = $;
  }
  return ListSemanticClass;
}
var ListSemantic_instance;
function ListSemantic_getInstance() {
  if (ListSemantic_instance === VOID)
    new (ListSemantic())();
  return ListSemantic_instance;
}
var DialogSemanticClass;
function DialogSemantic() {
  if (DialogSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        DialogSemantic_instance = null;
        super('dlg');
        DialogSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return theme.withBack_1;
      }
      toString() {
        return 'DialogSemantic';
      }
      hashCode() {
        return -1510628087;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DialogSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'DialogSemantic');
    DialogSemanticClass = $;
  }
  return DialogSemanticClass;
}
var DialogSemantic_instance;
function DialogSemantic_getInstance() {
  if (DialogSemantic_instance === VOID)
    new (DialogSemantic())();
  return DialogSemantic_instance;
}
var PopoverSemanticClass;
function PopoverSemantic() {
  if (PopoverSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        PopoverSemantic_instance = null;
        super('pop');
        PopoverSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return theme.withBack_1;
      }
      toString() {
        return 'PopoverSemantic';
      }
      hashCode() {
        return -408037104;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PopoverSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'PopoverSemantic');
    PopoverSemanticClass = $;
  }
  return PopoverSemanticClass;
}
var PopoverSemantic_instance;
function PopoverSemantic_getInstance() {
  if (PopoverSemantic_instance === VOID)
    new (PopoverSemantic())();
  return PopoverSemantic_instance;
}
var DismissSemanticClass;
function DismissSemantic() {
  if (DismissSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        DismissSemantic_instance = null;
        super('dsmss');
        DismissSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_gap = get_dp(0);
        var tmp1_cornerRadii = new (AdaptiveToSpacing())(get_dp(0));
        var tmp2_background = Companion_getInstance_0().black_1.applyAlpha_eeyl20_k$(0.5);
        return this.withBack$default_t8expd_k$(theme, false, VOID, VOID, tmp1_cornerRadii, VOID, tmp0_gap, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_background);
      }
      toString() {
        return 'DismissSemantic';
      }
      hashCode() {
        return -2096924683;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DismissSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'DismissSemantic');
    DismissSemanticClass = $;
  }
  return DismissSemanticClass;
}
var DismissSemantic_instance;
function DismissSemantic_getInstance() {
  if (DismissSemantic_instance === VOID)
    new (DismissSemantic())();
  return DismissSemantic_instance;
}
var SubtextSemanticClass;
function SubtextSemantic() {
  if (SubtextSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        SubtextSemantic_instance = null;
        super('sub');
        SubtextSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return this.withoutBack$default_y4jue9_k$(theme, VOID, theme.font_1.copy$default_cfilcw_k$(VOID, VOID, VOID, VOID, VOID, VOID, get_rem(0.8)), VOID, VOID, VOID, VOID, VOID, applyAlpha(theme.foreground_1, 0.7));
      }
      toString() {
        return 'SubtextSemantic';
      }
      hashCode() {
        return -1030941224;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SubtextSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'SubtextSemantic');
    SubtextSemanticClass = $;
  }
  return SubtextSemanticClass;
}
var SubtextSemantic_instance;
function SubtextSemantic_getInstance() {
  if (SubtextSemantic_instance === VOID)
    new (SubtextSemantic())();
  return SubtextSemantic_instance;
}
var WarningSemanticClass;
function WarningSemantic() {
  if (WarningSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        WarningSemantic_instance = null;
        super('wrn');
        WarningSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_background = Companion_getInstance_0().fromHex_s0l3vd_k$(-1872348);
        var tmp1_outline = Companion_getInstance_0().fromHex_s0l3vd_k$(-1872348).highlight_bst4u4_k$(0.1);
        var tmp2_foreground = Companion_getInstance_0().white_1;
        return this.withBack$default_t8expd_k$(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_foreground, VOID, tmp1_outline, VOID, VOID, tmp0_background);
      }
      toString() {
        return 'WarningSemantic';
      }
      hashCode() {
        return 2145927943;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof WarningSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'WarningSemantic');
    WarningSemanticClass = $;
  }
  return WarningSemanticClass;
}
var WarningSemantic_instance;
function WarningSemantic_getInstance() {
  if (WarningSemantic_instance === VOID)
    new (WarningSemantic())();
  return WarningSemantic_instance;
}
var DangerSemanticClass;
function DangerSemantic() {
  if (DangerSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        DangerSemantic_instance = null;
        super('dgr');
        DangerSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_background = Companion_getInstance_0().fromHex_s0l3vd_k$(-5242848);
        var tmp1_outline = Companion_getInstance_0().fromHex_s0l3vd_k$(-5242848).highlight_bst4u4_k$(0.1);
        var tmp2_foreground = Companion_getInstance_0().white_1;
        return this.withBack$default_t8expd_k$(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_foreground, VOID, tmp1_outline, VOID, VOID, tmp0_background);
      }
      toString() {
        return 'DangerSemantic';
      }
      hashCode() {
        return -2122468636;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DangerSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'DangerSemantic');
    DangerSemanticClass = $;
  }
  return DangerSemanticClass;
}
var DangerSemantic_instance;
function DangerSemantic_getInstance() {
  if (DangerSemantic_instance === VOID)
    new (DangerSemantic())();
  return DangerSemantic_instance;
}
var AffirmativeSemanticClass;
function AffirmativeSemantic() {
  if (AffirmativeSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        AffirmativeSemantic_instance = null;
        super('afr');
        AffirmativeSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_background = Companion_getInstance_0().fromHex_s0l3vd_k$(-14639072);
        var tmp1_outline = Companion_getInstance_0().fromHex_s0l3vd_k$(-14639072).highlight_bst4u4_k$(0.1);
        var tmp2_foreground = Companion_getInstance_0().white_1;
        return this.withBack$default_t8expd_k$(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_foreground, VOID, tmp1_outline, VOID, VOID, tmp0_background);
      }
      toString() {
        return 'AffirmativeSemantic';
      }
      hashCode() {
        return -664073043;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AffirmativeSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'AffirmativeSemantic');
    AffirmativeSemanticClass = $;
  }
  return AffirmativeSemanticClass;
}
var AffirmativeSemantic_instance;
function AffirmativeSemantic_getInstance() {
  if (AffirmativeSemantic_instance === VOID)
    new (AffirmativeSemantic())();
  return AffirmativeSemantic_instance;
}
var ErrorSemanticClass;
function ErrorSemantic() {
  if (ErrorSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        ErrorSemantic_instance = null;
        super('err');
        ErrorSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return this.withoutBack$default_y4jue9_k$(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, theme.get_6y9l0r_k$(DangerSemantic_getInstance()).theme_1.background_1.closestColor_akwbqu_k$().highlight_bst4u4_k$(0.2));
      }
      toString() {
        return 'ErrorSemantic';
      }
      hashCode() {
        return 877123251;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ErrorSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'ErrorSemantic');
    ErrorSemanticClass = $;
  }
  return ErrorSemanticClass;
}
var ErrorSemantic_instance;
function ErrorSemantic_getInstance() {
  if (ErrorSemantic_instance === VOID)
    new (ErrorSemantic())();
  return ErrorSemantic_instance;
}
var ClickableSemanticClass;
function ClickableSemantic() {
  if (ClickableSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        ClickableSemantic_instance = null;
        super('clk');
        ClickableSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return theme.withoutBackButPadding_1;
      }
      toString() {
        return 'ClickableSemantic';
      }
      hashCode() {
        return 1565914893;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ClickableSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'ClickableSemantic');
    ClickableSemanticClass = $;
  }
  return ClickableSemanticClass;
}
var ClickableSemantic_instance;
function ClickableSemantic_getInstance() {
  if (ClickableSemantic_instance === VOID)
    new (ClickableSemantic())();
  return ClickableSemantic_instance;
}
var FieldSemanticClass;
function FieldSemantic() {
  if (FieldSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        FieldSemantic_instance = null;
        super('fld');
        FieldSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_outlineWidth = get_px(1);
        var base = theme.cornerRadii_1;
        var tmp;
        if (base instanceof AdaptiveToSpacing()) {
          tmp = new (Fixed())(base.value_1);
        } else {
          if (base instanceof Fixed()) {
            tmp = base;
          } else {
            if (base instanceof RatioOfSize()) {
              tmp = base;
            } else {
              if (base instanceof RatioOfSpacing()) {
                tmp = new (Fixed())(times(theme.gap_1, base.value_1));
              } else {
                if (base instanceof PerCorner()) {
                  tmp = base;
                } else {
                  noWhenBranchMatchedException();
                }
              }
            }
          }
        }
        var tmp1_cornerRadii = tmp;
        return this.withBack$default_t8expd_k$(theme, false, VOID, VOID, tmp1_cornerRadii, VOID, VOID, VOID, VOID, VOID, VOID, tmp0_outlineWidth);
      }
      toString() {
        return 'FieldSemantic';
      }
      hashCode() {
        return 1431606181;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FieldSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'FieldSemantic');
    FieldSemanticClass = $;
  }
  return FieldSemanticClass;
}
var FieldSemantic_instance;
function FieldSemantic_getInstance() {
  if (FieldSemantic_instance === VOID)
    new (FieldSemantic())();
  return FieldSemantic_instance;
}
var InvalidSemanticClass;
function InvalidSemantic() {
  if (InvalidSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        InvalidSemantic_instance = null;
        super('ivd');
        InvalidSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_outlineWidth = get_px(1);
        var tmp1_outline = Companion_getInstance_0().red_1;
        return this.withBack$default_t8expd_k$(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_outline, tmp0_outlineWidth);
      }
      toString() {
        return 'InvalidSemantic';
      }
      hashCode() {
        return -1599866270;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof InvalidSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'InvalidSemantic');
    InvalidSemanticClass = $;
  }
  return InvalidSemanticClass;
}
var InvalidSemantic_instance;
function InvalidSemantic_getInstance() {
  if (InvalidSemantic_instance === VOID)
    new (InvalidSemantic())();
  return InvalidSemantic_instance;
}
function FocusSemantic$default$lambda(it) {
  return it.highlight_bst4u4_k$(1.0);
}
var FocusSemanticClass;
function FocusSemantic() {
  if (FocusSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        FocusSemantic_instance = null;
        super('fcs');
        FocusSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_outlineWidth = plus(theme.outlineWidth_1, get_dp(2));
        var tmp1_outline = theme.background_1.map_p3tssl_k$(FocusSemantic$default$lambda);
        return this.withBack$default_t8expd_k$(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_outline, tmp0_outlineWidth);
      }
      toString() {
        return 'FocusSemantic';
      }
      hashCode() {
        return -1605596797;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FocusSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'FocusSemantic');
    FocusSemanticClass = $;
  }
  return FocusSemanticClass;
}
var FocusSemantic_instance;
function FocusSemantic_getInstance() {
  if (FocusSemantic_instance === VOID)
    new (FocusSemantic())();
  return FocusSemantic_instance;
}
var SelectedSemanticClass;
function SelectedSemantic() {
  if (SelectedSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        SelectedSemantic_instance = null;
        super('sel');
        SelectedSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return theme.get_6y9l0r_k$(DownSemantic_getInstance());
      }
      toString() {
        return 'SelectedSemantic';
      }
      hashCode() {
        return 240946332;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SelectedSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'SelectedSemantic');
    SelectedSemanticClass = $;
  }
  return SelectedSemanticClass;
}
var SelectedSemantic_instance;
function SelectedSemantic_getInstance() {
  if (SelectedSemantic_instance === VOID)
    new (SelectedSemantic())();
  return SelectedSemantic_instance;
}
var UnselectedSemanticClass;
function UnselectedSemantic() {
  if (UnselectedSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        UnselectedSemantic_instance = null;
        super('uns');
        UnselectedSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_background = applyAlpha(theme.background_1, 0.0);
        var tmp1_outline = theme.background_1;
        var tmp2_outlineWidth = get_dp(2);
        return this.withBack$default_t8expd_k$(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_outline, tmp2_outlineWidth, VOID, tmp0_background);
      }
      toString() {
        return 'UnselectedSemantic';
      }
      hashCode() {
        return -2039615883;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof UnselectedSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'UnselectedSemantic');
    UnselectedSemanticClass = $;
  }
  return UnselectedSemanticClass;
}
var UnselectedSemantic_instance;
function UnselectedSemantic_getInstance() {
  if (UnselectedSemantic_instance === VOID)
    new (UnselectedSemantic())();
  return UnselectedSemantic_instance;
}
function HoverSemantic$default$lambda(it) {
  return it.highlight_bst4u4_k$(0.2);
}
function HoverSemantic$default$lambda_0(it) {
  return it.highlight_bst4u4_k$(0.2).highlight_bst4u4_k$(0.1);
}
var HoverSemanticClass;
function HoverSemantic() {
  if (HoverSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        HoverSemantic_instance = null;
        super('hov');
        HoverSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_background = theme.background_1.map_p3tssl_k$(HoverSemantic$default$lambda);
        var tmp1_outline = theme.background_1.map_p3tssl_k$(HoverSemantic$default$lambda_0);
        var tmp2_elevation = times(theme.elevation_1, 2.0);
        return this.withBack$default_t8expd_k$(theme, VOID, VOID, tmp2_elevation, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_outline, VOID, VOID, tmp0_background);
      }
      toString() {
        return 'HoverSemantic';
      }
      hashCode() {
        return -1318037017;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HoverSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'HoverSemantic');
    HoverSemanticClass = $;
  }
  return HoverSemanticClass;
}
var HoverSemantic_instance;
function HoverSemantic_getInstance() {
  if (HoverSemantic_instance === VOID)
    new (HoverSemantic())();
  return HoverSemantic_instance;
}
function DownSemantic$default$lambda(it) {
  return it.highlight_bst4u4_k$(0.3);
}
function DownSemantic$default$lambda_0(it) {
  return it.highlight_bst4u4_k$(0.3).highlight_bst4u4_k$(0.1);
}
var DownSemanticClass;
function DownSemantic() {
  if (DownSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        DownSemantic_instance = null;
        super('dwn');
        DownSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_background = theme.background_1.map_p3tssl_k$(DownSemantic$default$lambda);
        var tmp1_outline = theme.background_1.map_p3tssl_k$(DownSemantic$default$lambda_0);
        var tmp2_elevation = div(theme.elevation_1, 2.0);
        return this.withBack$default_t8expd_k$(theme, VOID, VOID, tmp2_elevation, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_outline, VOID, VOID, tmp0_background);
      }
      toString() {
        return 'DownSemantic';
      }
      hashCode() {
        return -822702813;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DownSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'DownSemantic');
    DownSemanticClass = $;
  }
  return DownSemanticClass;
}
var DownSemantic_instance;
function DownSemantic_getInstance() {
  if (DownSemantic_instance === VOID)
    new (DownSemantic())();
  return DownSemantic_instance;
}
var DisabledSemanticClass;
function DisabledSemantic() {
  if (DisabledSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        DisabledSemantic_instance = null;
        super('dis');
        DisabledSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_foreground = applyAlpha(theme.foreground_1, 0.25);
        var tmp1_background = applyAlpha(theme.background_1, 0.5);
        var tmp2_outline = applyAlpha(theme.outline_1, 0.25);
        return this.withBack$default_t8expd_k$(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp0_foreground, VOID, tmp2_outline, VOID, VOID, tmp1_background);
      }
      toString() {
        return 'DisabledSemantic';
      }
      hashCode() {
        return 40592253;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DisabledSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'DisabledSemantic');
    DisabledSemanticClass = $;
  }
  return DisabledSemanticClass;
}
var DisabledSemantic_instance;
function DisabledSemantic_getInstance() {
  if (DisabledSemantic_instance === VOID)
    new (DisabledSemantic())();
  return DisabledSemantic_instance;
}
var WorkingSemanticClass;
function WorkingSemantic() {
  if (WorkingSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        WorkingSemantic_instance = null;
        super('wrk');
        WorkingSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp = applyAlpha(theme.foreground_1, 0.5);
        var tmp0_safe_receiver = theme.iconOverride_1;
        return this.withoutBack$default_y4jue9_k$(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp, tmp0_safe_receiver == null ? null : applyAlpha(tmp0_safe_receiver, 0.5));
      }
      toString() {
        return 'WorkingSemantic';
      }
      hashCode() {
        return -1024173668;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof WorkingSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'WorkingSemantic');
    WorkingSemanticClass = $;
  }
  return WorkingSemanticClass;
}
var WorkingSemantic_instance;
function WorkingSemantic_getInstance() {
  if (WorkingSemantic_instance === VOID)
    new (WorkingSemantic())();
  return WorkingSemantic_instance;
}
var LoadingSemanticClass;
function LoadingSemantic() {
  if (LoadingSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        LoadingSemantic_instance = null;
        super('ld');
        LoadingSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp1_background = new (FadingColor())(theme.background_1.closestColor_akwbqu_k$().highlight_bst4u4_k$(0.1), theme.background_1.closestColor_akwbqu_k$().highlight_bst4u4_k$(0.2));
        var tmp2_outline = new (FadingColor())(theme.outline_1.closestColor_akwbqu_k$().highlight_bst4u4_k$(0.1), theme.outline_1.closestColor_akwbqu_k$().highlight_bst4u4_k$(0.2));
        var tmp3_foreground = applyAlpha(theme.foreground_1, 0.3);
        var tmp0_safe_receiver = theme.iconOverride_1;
        var tmp4_iconOverride = tmp0_safe_receiver == null ? null : applyAlpha(tmp0_safe_receiver, 0.3);
        return this.alter$default_u3pj3s_k$(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp3_foreground, tmp4_iconOverride, tmp2_outline, VOID, VOID, tmp1_background).withBackNoPadding_1;
      }
      toString() {
        return 'LoadingSemantic';
      }
      hashCode() {
        return -638069593;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LoadingSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'LoadingSemantic');
    LoadingSemanticClass = $;
  }
  return LoadingSemanticClass;
}
var LoadingSemantic_instance;
function LoadingSemantic_getInstance() {
  if (LoadingSemantic_instance === VOID)
    new (LoadingSemantic())();
  return LoadingSemantic_instance;
}
var CompactSemanticClass;
function CompactSemantic() {
  if (CompactSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        CompactSemantic_instance = null;
        super('cmp');
        CompactSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return this.withoutBack$default_y4jue9_k$(theme, VOID, VOID, VOID, VOID, VOID, div_0(theme.gap_1, 2), theme.padding_1.div_fxyyjd_k$(2));
      }
      toString() {
        return 'CompactSemantic';
      }
      hashCode() {
        return -1662691442;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CompactSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'CompactSemantic');
    CompactSemanticClass = $;
  }
  return CompactSemanticClass;
}
var CompactSemantic_instance;
function CompactSemantic_getInstance() {
  if (CompactSemantic_instance === VOID)
    new (CompactSemantic())();
  return CompactSemantic_instance;
}
var ForcePaddingSemanticClass;
function ForcePaddingSemantic() {
  if (ForcePaddingSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        ForcePaddingSemantic_instance = null;
        super('fpad');
        ForcePaddingSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        return theme.withoutBackButPadding_1;
      }
      toString() {
        return 'ForcePaddingSemantic';
      }
      hashCode() {
        return 1393988647;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ForcePaddingSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'ForcePaddingSemantic');
    ForcePaddingSemanticClass = $;
  }
  return ForcePaddingSemanticClass;
}
var ForcePaddingSemantic_instance;
function ForcePaddingSemantic_getInstance() {
  if (ForcePaddingSemantic_instance === VOID)
    new (ForcePaddingSemantic())();
  return ForcePaddingSemantic_instance;
}
var PrintSemanticClass;
function PrintSemantic() {
  if (PrintSemanticClass === VOID) {
    class $ extends Semantic() {
      constructor() {
        PrintSemantic_instance = null;
        super('print');
        PrintSemantic_instance = this;
      }
      default_buqihh_k$(theme) {
        var tmp0_background = Companion_getInstance_0().white_1;
        var tmp1_foreground = Companion_getInstance_0().black_1;
        var tmp2_outline = theme.background_1;
        var tmp3_outlineWidth = get_px(2);
        return this.withBack$default_t8expd_k$(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_foreground, VOID, tmp2_outline, tmp3_outlineWidth, VOID, tmp0_background);
      }
      toString() {
        return 'PrintSemantic';
      }
      hashCode() {
        return 1813922392;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PrintSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'PrintSemantic');
    PrintSemanticClass = $;
  }
  return PrintSemanticClass;
}
var PrintSemantic_instance;
function PrintSemantic_getInstance() {
  if (PrintSemantic_instance === VOID)
    new (PrintSemantic())();
  return PrintSemantic_instance;
}
var properties_initialized_Theme_kt_uwj6hl;
function _init_properties_Theme_kt__w31tqv() {
  if (!properties_initialized_Theme_kt_uwj6hl) {
    properties_initialized_Theme_kt_uwj6hl = true;
    H1Semantic = new (HeaderSizeSemantic())(1);
    H2Semantic = new (HeaderSizeSemantic())(2);
    H3Semantic = new (HeaderSizeSemantic())(3);
    H4Semantic = new (HeaderSizeSemantic())(4);
    H5Semantic = new (HeaderSizeSemantic())(5);
    H6Semantic = new (HeaderSizeSemantic())(6);
  }
}
//region block: init
None_instance = new (None())();
//endregion
//region block: exports
export {
  get_H1Semantic as get_H1Semantic28sytsa4fm6nk,
  get_H2Semantic as get_H2Semantic1i9pxrezr3hyb,
  get_H3Semantic as get_H3Semantic2xvwj5aimpbn,
  get_H4Semantic as get_H4Semantic111wmmqwoslob,
  get_H5Semantic as get_H5Semantic2z0efuo572r3d,
  HeaderSizeSemantic as HeaderSizeSemantickc8o84qqqkjf,
  Semantic as Semanticpmpmvt7fldq2,
  SetAsBase as SetAsBase1p1kkt5i4f45k,
  plus_1 as plus354lvypr4cqa1,
  ThemeDerivation as ThemeDerivation3kcl449hwgd5y,
  Theme as Themeex1jjdf3pz9y,
  Transformation as Transformation3lzjezr9l4f8c,
  override as override1oesdgz72e8ey,
  _SemanticOverrides___init__impl__g2p3k8_1 as _SemanticOverrides___init__impl__g2p3k812zbkczmal1zf,
  AffirmativeSemantic_getInstance as AffirmativeSemantic_getInstance2svzxainpava5,
  BarSemantic_getInstance as BarSemantic_getInstance1mitybcla04dq,
  ButtonSemantic_getInstance as ButtonSemantic_getInstance3q30xblp6a1af,
  CardSemantic_getInstance as CardSemantic_getInstancelcny5le8pbc4,
  ClickableSemantic_getInstance as ClickableSemantic_getInstance29tidgppnw5x2,
  CompactSemantic_getInstance as CompactSemantic_getInstance3lxnpjuev524m,
  DangerSemantic_getInstance as DangerSemantic_getInstance1xd9zwrvs99lp,
  DialogSemantic_getInstance as DialogSemantic_getInstance1e2v1jwywf0uw,
  DisabledSemantic_getInstance as DisabledSemantic_getInstancet3o5kouryhbf,
  DismissSemantic_getInstance as DismissSemantic_getInstanceoxgbstxq9t8s,
  DownSemantic_getInstance as DownSemantic_getInstancejvxqp4oqx0tj,
  ErrorSemantic_getInstance as ErrorSemantic_getInstance1asme2of31cag,
  FieldSemantic_getInstance as FieldSemantic_getInstancer1p3l15xmphu,
  FocusSemantic_getInstance as FocusSemantic_getInstance1u11pdt9aclin,
  ForcePaddingSemantic_getInstance as ForcePaddingSemantic_getInstance2xrz1oepj1itn,
  HeaderSemantic_getInstance as HeaderSemantic_getInstance20a9id3sf7d4x,
  HoverSemantic_getInstance as HoverSemantic_getInstance3081oh8o0tv4w,
  ImportantSemantic_getInstance as ImportantSemantic_getInstancehm7lt56tp87l,
  InvalidSemantic_getInstance as InvalidSemantic_getInstance2x7tbxxpbj713,
  ListSemantic_getInstance as ListSemantic_getInstance2e62q1se6gw64,
  LoadingSemantic_getInstance as LoadingSemantic_getInstance2uz34omnpc1bs,
  MainContentSemantic_getInstance as MainContentSemantic_getInstance31xiavoja82c3,
  NavSemantic_getInstance as NavSemantic_getInstance3hcdsyfduq9gu,
  OuterSemantic_getInstance as OuterSemantic_getInstance3f4lrw2322ga8,
  PopoverSemantic_getInstance as PopoverSemantic_getInstanceyx37zl2h0qnj,
  PrintSemantic_getInstance as PrintSemantic_getInstance20sw3wh3j3vdl,
  SelectedSemantic_getInstance as SelectedSemantic_getInstance3adr60xrkcq3z,
  SubtextSemantic_getInstance as SubtextSemantic_getInstance1duu1ll1kgx8d,
  Companion_getInstance_4 as Companion_getInstanceoo2y82hqzamu,
  None_instance as None_instance1vdtnxdfytk8h,
  UnselectedSemantic_getInstance as UnselectedSemantic_getInstance1xc7cb2k39ftl,
  WarningSemantic_getInstance as WarningSemantic_getInstance3kp0xfef7wnw4,
  WorkingSemantic_getInstance as WorkingSemantic_getInstance1c0k8igfs4qnm,
};
//endregion

//# sourceMappingURL=Theme.mjs.map
